import 'lite-youtube-embed'
import 'lite-youtube-embed/src/lite-yt-embed.css'

export default defineNuxtPlugin(() => {})
